<template>
  <!-- 对齐 App nearby.dart：AppHeader + CardContainer + Tab + 列表 + EmptyState + BottomNav -->
  <div class="nearby-page">
    <app-header :title="i18n.nearby_venues"></app-header>

    <card-container>
      <!-- Tab 行：All / Available / Returnable -->
      <div class="nearby-tabs">
        <div
          v-for="(tab, idx) in tabs"
          :key="idx"
          class="nearby-tab"
          :class="{ active: tabIndex === idx }"
          @click="onTabChange(idx)"
        >
          {{ tab }}
        </div>
      </div>

      <!-- 列表（带下拉刷新） -->
      <div class="nearby-scroll">
        <div class="nearby-list" v-if="filteredList.length">
          <div
            class="nearby-item"
            v-for="item in filteredList"
            :key="item.id"
          >
            <shop-item :item="item"></shop-item>
          </div>
        </div>

        <!-- 空状态（使用公共组件） -->
        <empty-state
          v-else-if="!loading"
          :text="i18n.no_data"
        ></empty-state>

        <div v-else class="nearby-loading">Loading...</div>
      </div>

      <bottom-nav class="nearby-bottom-nav"></bottom-nav>
    </card-container>
  </div>
</template>

<script>
import { mapState } from "vuex"
import { SHOP_LIST } from "../../apis/cabinet"
import ShopItem from "./shopItem.vue"
import AppHeader from "../../components/common/AppHeader.vue"
import CardContainer from "../../components/common/CardContainer.vue"
import EmptyState from "../../components/common/EmptyState.vue"
import BottomNav from "../../components/common/BottomNav.vue"

export default {
  components: {
    ShopItem,
    AppHeader,
    CardContainer,
    EmptyState,
    BottomNav
  },
  computed: {
    i18n() {
      return this.$t("shop")
    },
    filteredList() {
      const list = this.shopList || []
      if (this.tabIndex === 0) return list
      return list.filter((item) => {
        const isOnline = item.infoStatus === "在线"
        if (this.tabIndex === 1) return isOnline && (parseInt(item.freeNum) || 0) > 0
        if (this.tabIndex === 2) return isOnline && (Number(item.canReturnNum) || 0) > 0
        return true
      })
    }
  },
  data() {
    return {
      loading: false,
      shopList: [],
      tabIndex: 0,
      tabs: [],
      lat: null,
      lng: null
    }
  },
  methods: {
    onTabChange(idx) {
      this.tabIndex = idx
    },
    getLocation() {
      return new Promise((resolve) => {
        if (!navigator.geolocation) return resolve(null)
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude })
          },
          () => resolve(null),
          { timeout: 8000, maximumAge: 60000 }
        )
      })
    },
    async loadList() {
      this.loading = true
      let { lat, lng } = this.$route.query
      if (!lat || !lng) {
        const loc = await this.getLocation()
        if (loc) {
          lat = loc.lat
          lng = loc.lng
        }
      }
      if (!lat || !lng) {
        lat = 22.631123
        lng = 113.820622
      }
      this.lat = lat
      this.lng = lng

      const queryDate = {
        coordType: "WGS-84",
        mapType: "WGS-84",
        zoomLevel: 3,
        lat,
        lng,
        showPrice: true,
        usePriceUnit: true
      }
      const formdata = new FormData()
      Object.keys(queryDate).forEach((k) => formdata.append(k, queryDate[k]))

      this.$post(
        SHOP_LIST,
        formdata,
        (resp) => {
          this.$loading(false)
          this.shopList = resp.list || []
          this.loading = false
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
          this.loading = false
        },
        {
          headers: { "Content-Type": "multipart/form-data" }
        }
      )
    }
  },
  created() {
    this.tabs = [this.i18n.all, this.i18n.available, this.i18n.returnable]
    this.loadList()
  }
}
</script>

<style lang="less" scoped>
.nearby-page {
  position: relative;
  width: 100%;
  height: 100vh;
  background: var(--page-bg);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

// Tab 行
.nearby-tabs {
  display: flex;
  align-items: center;
  margin: 0 20px 10px;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0;
}

.nearby-tab {
  flex: 1;
  height: 80px;
  line-height: 80px;
  text-align: center;
  font-size: 32px;
  font-weight: 600;
  color: #000;
  cursor: pointer;
  position: relative;
  transition: color 0.2s;
  font-family: "Montserrat-SemiBold", sans-serif;

  &.active {
    color: var(--theme-color, #ff8800);
    font-weight: 900;

    &::after {
      content: "";
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      width: 80%;
      height: 6px;
      background: var(--theme-color, #ff8800);
      border-radius: 3px;
    }
  }
}

// 可滚动列表
.nearby-scroll {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  min-height: 0;
}

.nearby-list {
  padding: 20px 30px 48px;
}

.nearby-item {
  margin-bottom: 32px;
  &:last-child {
    margin-bottom: 0;
  }
}

.nearby-loading {
  padding: 200px 0 0;
  text-align: center;
  font-size: 30px;
  color: #999;
}

.nearby-bottom-nav {
  margin-top: auto;
  padding-bottom: 30px;
  flex-shrink: 0;
}
</style>
